// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import I18n from 'i18n-react'

import SuriApi from '../../Services/SuriApi'

// redux
import GeneralActions, { ERROR_TYPES } from '../Redux/GeneralRedux'
import OfferActions, { OfferTypes } from '../Redux/OfferRedux'

const OfferEpic = [
  action$ => (
    action$.pipe(
      ofType(OfferTypes.SEND_OFFER_REQUEST),
      switchMap(action => (
        from(SuriApi.publicOfferSend(action.timeout, action.data)).pipe(
          switchMap(() => {
            return of(OfferActions.sendOfferRequestSuccess())
          }),
          catchError(e => of(GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.WARNING)))
        )
      ))
    )
  ),

  action$ => (
    action$.pipe(
      ofType(OfferTypes.SEND_OFFER_REQUEST_VIA_CRM_LOADER_OFF),
      switchMap(action => (
        from(SuriApi.publicOfferSendViaCrm(action.email, action.data)).pipe(
          switchMap(() =>
            from([
              OfferActions.sendOfferRequestSuccess(),
              GeneralActions.addSuccessNotification(I18n.translate('general.sendEmailOffersSuccess'))
            ])
          ),
          catchError((e) =>
            from([
              GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.WARNING),
              GeneralActions.addErrorNotification(I18n.translate('general.sendEmailOffersFailure'))
            ])
          )
        )
      ))
    )
  ),
  action$ => (
    action$.pipe(
      ofType(OfferTypes.SEND_BO_OFFER_REQUEST_VIA_EMAIL_LOADER_OFF),
      switchMap(action => (
          from(SuriApi.boOfferSendViaEmail(action.email, action.data, action.productName)).pipe(
            switchMap(() => {
              return from([
                OfferActions.sendBoOfferRequestSuccess(),
                GeneralActions.addSuccessNotification(I18n.translate('general.sendEmailOffersSuccess')),
              ])
            }),
            catchError(e =>
              from([
                GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.WARNING),
                GeneralActions.addErrorNotification(I18n.translate('general.sendEmailOffersFailure')),
              ]))
          )
        )
      ))
  )
]

export default OfferEpic
